<template>
    <div>
        <!-- <apexchart v-if="projectModels" type="line" height="220" :options="options" :series="series"></apexchart> -->
        <p v-if="!projectModels">
            <b-skeleton height="50px"></b-skeleton>
            <b-skeleton height="300px"></b-skeleton>
        </p>
        <b-table 
            v-if="projectModels"
            :data="projectModels"
            :per-page="10"
            :total="projectModels.length"
            :default-sort="['createdAt']"
            pagination-position="bottom"
            paginated>
            <b-table-column width="1%" field="id" label="Active" v-slot="props">
                <center>
                <b-tooltip
                    label="Enable this model for continuous training. It will automatically update itself whenever you add, edit, or delete a record, annotate, or update a project."
                    position="is-bottom"
                    size="is-medium"
                    multilined>
                    <b-radio v-model="project.modelId"
                            @input="saveCurrentModelId"
                            :native-value="props.row.id">
                        </b-radio>
                </b-tooltip>
            </center>
            </b-table-column>
            <b-table-column width="30%" field="id" label="Model version" v-slot="props">
                <a @click="openMetrics(props.row.id)">
                    <b-field grouped group-multiline>
            <div class="control">
                <b-taglist attached>
                        <b-tag>
                            <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"/></svg>
                            &nbsp;Metrics
                        </b-tag>
                        <b-tag type="is-white">
                            {{ props.row.id }}
                        </b-tag>
                </b-taglist>
            </div>
            </b-field>
                
                </a>    
            </b-table-column>
            <b-table-column width="1%" field="s" label="" v-slot="props">
                
            </b-table-column>
            <b-table-column width="5%" field="status" label="Credits" v-slot="props">
                {{ ( props.row.creditsCost ? props.row.creditsCost : '0') }}
            </b-table-column>
            
            <b-table-column width="5%" field="status" label="Status" v-slot="props">
                {{ ( props.row.job ? props.row.job.status : '-') }}
            </b-table-column>
            <b-table-column width="5%" field="model_metrics" label="F1score" v-slot="props">
                {{ (props.row.model_metrics !== undefined ? parseFloat(props.row.model_metrics["f1score"]) : 0.00).toFixed(3) }}
            </b-table-column>
            
            <b-table-column width="5%" field="model_metrics" label="Accuracy" v-slot="props">
                {{ (props.row.model_metrics !== undefined ? parseFloat(props.row.model_metrics["accuracy"]) : 0.00).toFixed(3) }}
            </b-table-column>
            
            <b-table-column width="2%" field="model_metrics" label="Precision" v-slot="props">
                {{ (props.row.model_metrics !== undefined ? parseFloat(props.row.model_metrics["precision"]) : 0.00).toFixed(3) }}
            </b-table-column>
            <b-table-column width="2%" field="model_metrics" label="Recall" v-slot="props">
                {{ (props.row.model_metrics !== undefined ? parseFloat(props.row.model_metrics["recall"]) : 0.00).toFixed(3) }}
            </b-table-column>
            <b-table-column width="5%" field="training_status" label="Size" v-slot="props">
                {{ ( props.row.size ? props.row.size : '-') }}
            </b-table-column>
            <b-table-column width="5%" field="model_metrics" label="Language" v-slot="props">
                {{ ( props.row.language ? props.row.language : '-') }}
            </b-table-column>
            <b-table-column width="30%" field="createdAt" label="Updated" v-slot="props">
                {{ props.row.createdAt.toDate().toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }) }}
            </b-table-column>
            
        </b-table>
    
    <b-modal
          v-model="isModalTrainingMetricsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          scroll="keep">
          <template #default="props">
             <TrainingMetrics @close="props.close" :modelId="modelId"></TrainingMetrics>
          </template>
       </b-modal>
    </div>
</template>
<script>
import TrainingMetrics from "@/dashboard/Model/Training.vue";
   export default {
     props: ["project"],
     name: "TrainRuns",
     data: function() {
        return {
            isModalTrainingMetricsOpen: false,
            modelId: null,
            options: {},
            series: [],
            selected: []
        }
    },
    components: {
        TrainingMetrics
    },
    computed: {
        projectModels(){
            return this.$store.state.projectModels
        }
     },
     methods: {
        openMetrics(modelId){
            this.modelId = modelId
            this.isModalTrainingMetricsOpen = true
        },
        async saveCurrentModelId(){
            const model = await this.$store.dispatch("currentModel", 
                this.project.modelId
            )

            const toUpdate = {
                projectId: this.project.id,
                update: {
                    modelId: this.project.modelId,
                    model_metrics: model.model_metrics ? model.model_metrics : this.project.model_metrics
                }
            }
            this.$store.dispatch("updateProject", 
                toUpdate
            );
        },
        build_plot(){
            
            let dates = this.projectModels.map(({ createdAt }) => createdAt.toDate() )
            let modelId = this.projectModels.map(({ modelId }) => modelId )
            let scores = this.projectModels.map(({ model_metrics }) => (model_metrics?model_metrics['f1score']:0.1)) 
            
            this.options = {
                chart: {
                    id: 'response-time-plotx'
                },
                xaxis: {
                    categories: dates
                }
            }

            this.series = [{
                name: "f1score",
                data: scores
            },{
                name: "prediction",
                data: scores
            }]
        }
     },
     mounted(){
        this.$store.dispatch("projectModels", this.project.id)
        if(this.projectModels){
            this.build_plot()
            // this.selected = this.projectModels.filter( model => model.modelId == this.project.modelId)
        }
     },
     created(){
        this.$store.dispatch("projectModels", this.project.id).then( () => {
            this.build_plot()
        })
     }
   }
</script>